import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';

import PageTitle from '../../../components/pageTitle';
import Search from '../../../components/searchField';
import KBCategory from './kbCategoryList';
import KBPost from './kbPostList';
import Navigation from '../../../components/navigation';
import Post from './post';
import SearchedPosts from './searchedPosts';

const KnowledgeBase = ({
  t,
  posts,
  goBack,
  isLoad,
  showBack,
  postsCount,
  activePost,
  choosePost,
  searchedPosts,
  hasMoreSearch,
  postsCriteria,
  activeCategory,
  backgroundColor,
  backgroundCover,
  callbackToSetSearch,
  moduleTitle,
  enableCoverColor,
  updateSearch,
  ...props }) => (
    <React.Fragment>
      <PageTitle
        title={moduleTitle}
        backgroundPage={backgroundColor}
        backgroundCover={backgroundCover}
        enableCoverColor={enableCoverColor}
      />
      <section className="Blog2 boxs knwldgeBase_D kb">
        <div className="container">
          <div className="Blog2inner boxs pdlr forlineBlog forlineBlogleft pdlrzero">
            <svg aria-hidden="true" focusable="false" className="svg-hidden">
              <linearGradient id="gradientfill" className={`emoj-list ${backgroundColor}`}>
                <stop offset="0%" stopColor="var(--color-stop-1)" />
                <stop offset="100%" stopColor="var(--color-stop-2)" />
              </linearGradient>
            </svg>
            <Navigation cssClass="leftKB" />
            <div className="middleKB">
              <div className="middleinner boxs">
                <Search
                  placeholder={t('Search articles')}
                  callbackToSetSearch={callbackToSetSearch}
                  update={updateSearch}
                />
                <div className="kbrightw">
                  <div
                    className={showBack ? 'dspl-none' : ''}
                  >
                    <KBCategory
                      postsCriteria={postsCriteria}
                      activeCategory={activeCategory}
                      {...props}
                    />
                  </div>
                  <div
                    className={backgroundColor + (!showBack ? ' dspl-none' : '')}
                  >
                    <a
                      href="#"
                      onClick={goBack}
                      className="tc goback-link"
                    >
                      <img
                        src="/img/arrowright.svg"
                        className="img-back"
                        alt="go back"
                      />
                      {t('Go back to categories')}
                    </a>
                    <KBPost
                      postsCriteria={postsCriteria}
                      postsCount={postsCount}
                      posts={posts}
                      activePost={activePost}
                      activeCategory={activeCategory}
                      choosePost={choosePost}
                      {...props}
                    />
                  </div>
                </div>
                <div className="kbleftw">
                  <div className="Blog2t_outer boxs">
                    <Switch>
                      <Route
                        exact
                        path="/kb/search-:value"
                        render={prop => (
                          <SearchedPosts
                            choosePost={choosePost}
                            {...prop}
                          />
                        )}
                      />
                      <Route
                        exact
                        path="/kb/:id"
                        render={prop => (
                          <Post backgroundColor={backgroundColor} {...prop} />
                      )}
                      />
                      <Route
                        exact
                        path="/kb"
                        render={prop => (
                          <SearchedPosts
                            choosePost={choosePost}
                            {...prop}
                          />
                        )}
                      />
                      <Redirect from="*" to="/kb" />
                    </Switch>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
);

KnowledgeBase.propTypes = {
  t: PropTypes.func.isRequired,
  callbackToSetSearch: PropTypes.func.isRequired,
};

export default KnowledgeBase;



// WEBPACK FOOTER //
// ./src/views/modules/kb/KnowledgeBase.jsx